<ng-container *ngIf="data$ | async as data"
  ><!-- Header -->
  <ng-container *ngIf="data.plannerLink">
  <div class="learn-header bg-white border-bottom">
    <div class="container-fluid py-2">
      <div class="row align-items-center">
        <div class="col-12 col-md-4 text-center text-md-start">
          <h1 class="mb-0">{{ data.plannerLink.name }}</h1>
        </div>
        <div class="col-12 col-md-4 text-center">
          <div class="date-display">
            <ng-container *ngIf="data$ | async as data">
              <h3 class="mb-0">{{ data.weeks[0].start.toDate() | date }}</h3>
            </ng-container>
          </div>
        </div>
        <div class="col-12 col-md-4 text-center text-md-end">
          <div
            class="navigation-group d-flex justify-content-center justify-content-md-end"
          >
            <button class="btn btn-link" (click)="goToPrevious()">
              <fa-icon [icon]="icons.prevIcon" size="lg"></fa-icon>
            </button>
            <button class="btn btn-link" (click)="goToToday()">
              <fa-icon [icon]="icons.todayIcon" size="lg"></fa-icon>
            </button>
            <button class="btn btn-link" (click)="goToNext()" [disabled]="!canNavigateNext()">
              <fa-icon [icon]="icons.nextIcon" size="lg"></fa-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div id="main">
    <div class="container-fluid py-3">
      <div *ngFor="let planner of data.plannerLink.planners" class="mb-1">
        <app-learn-planner
          [plannerLink]="data.plannerLink"
          [planner]="planner"
          [settings]="defaultSettings"
          [weeks]="data.weeks"
        />
      </div>
    </div>
  </div>

  <!-- Footer -->
  <footer class="learn-footer bg-white border-top mt-auto">
    <div class="container-fluid py-3">
      <div class="row align-items-center">
        <div class="col-12 col-md-6 text-center text-md-start">
          <small class="text-muted"
            >© 2024 ClassJax. All rights reserved.</small
          >
        </div>
        <div class="col-12 col-md-6 text-center text-md-end">
          <small class="text-muted"
            >Simplified planning, one day at a time.</small
          >
        </div>
      </div>
    </div>
  </footer>
  </ng-container>
</ng-container>
